<template>
    <div class="service-center-header">
        <Header>
            <div class="header_wrapper">
                <div class="left">
                    <span class="title">iCourt企业法律服务中台</span>
                    <div :class="'search-container-header'+(searchFocus?' active':'')" v-if="">
                        <Icon type="md-search"
                              v-if="searchShow"/>
                        <Input v-if="searchShow" placeholder="请输入您要搜索的内容" class="class-search"
                               @on-enter="searchEnter(searchText)"
                               @on-focus="searchFocus=true"
                               @on-blur="_handleBlur"
                               v-model="searchText"/>
                        <button class="search-btn" @click="searchEnter(searchText)">搜索</button>
                    </div>

                </div>
                <nav class="center">
                    <!--          <router-link class="nav_item" :to="{ path: '/home'}" active-class="active">首页</router-link>-->
                    <!--          <router-link class="nav_item" :to="{ path: '/lives'}" active-class="active">橙三直播</router-link>-->
                    <!-- <router-link class="nav_item" :to="{ path: '/download'}" active-class="active">APP下载</router-link> -->
                </nav>
                <div class="right">
                    <span class="welcome-info">{{welcomeInfo}}</span>
                    <span class="update-info" @click="updateShow=true"
                          v-if="systemNotice&&systemNotice.status&&systemNotice.noticeTime">
                        <span class="one one-speaker search-mail ico" @click="showMail()"/>
                        <span class="text">更新推荐</span>
                    </span>
                    <span class="one one-email search-mail ico" @click="showMail()"/>
                    <Dropdown v-if="isLogin" @on-click="handleProfile">
                        <Avatar :src="avatar||`/img/avatar-male.svg`"/>
                        <DropdownMenu slot="list">
                            <DropdownItem name="logout">登出</DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                    <VuiButton v-else type="warning" round @click.native="login">登录</VuiButton>
                </div>
            </div>
        </Header>
        <UpdateMessage :updateShow="updateShow" @updateHide="updateHide()"
                       :contents="JSON.parse(systemNotice&&systemNotice.info||'[]')"></UpdateMessage>
        <Mail :mailShow="mailShow" @updateHide="mailHide()"></Mail>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import UpdateMessage from "./UpdateMessage";
    import {dateStringFrom} from '@/utils'
    import Mail from "./Mail";
    import storage from '@/plugins/storage'

    export default {
        data() {
            return {
                welcomeInfo: `${dateStringFrom('T', new Date())},${storage.get('userinfo').userName || storage.get('userinfo').name}律师`,
                updateShow: false,
                searchFocus: false,
                searchShow: false,
                path: '',
                mailShow: false,
                redirectUrl: this.$config.courseFilesDomain,
                searchText: this.$router.currentRoute.query.keyword || ''
            }
        },
        components: {UpdateMessage, Mail},
        watch: {
            $route(to, from) {
                this.searchText = to.query.keyword || ''
                this.path =to.path
                this.searchShow = (this.path.indexOf('online-course') > -1 || this.path.indexOf('service-center/prodbook') > -1 || this.path.indexOf('service-center/entcourse') > -1 || this.path.indexOf('service-center/corporate-template-course')>-1 || this.path.indexOf('service-center/skill-course')>-1)
                console.log( this.searchShow,' this.searchShow')
            }
        },
        computed: {
            ...mapState('app', {
                isLogin: state => state.isLogin,
                systemNotice: state => state.systemNotice,
                avatar: state => state.userinfo.avatar
            }),
        },
        mounted() {
            setTimeout(() => {
                this.mailShow = storage.get('userinfo').showLetter
                this.path = this.$router.currentRoute.path
                this.searchShow = (this.path.indexOf('online-course') > -1 || this.path.indexOf('service-center/prodbook') > -1 || this.path.indexOf('service-center/entcourse') > -1 || this.path.indexOf('service-center/corporate-template-course')>-1 || this.path.indexOf('service-center/skill-course')>-1)
            }, 1000)
        },
        methods: {
            updateHide() {
                this.updateShow = false
            },
            mailHide() {
                this.mailShow = false
                let userInfo = storage.get('userinfo')
                userInfo.showLetter = false
                this.$store.commit('app/setUserInfo', userInfo)
            },
            showMail() {
                this.mailShow = true
            },
            searchEnter(searchText) {
                this.$router.push(`${this.$router.currentRoute.path}?keyword=${searchText}`)
            },
            handleProfile(val) {
                if (val === 'logout') {
                    this.$store.dispatch('app/quit', {path: '/service-center-login'})
                }
            },
            login() {
                this.$router.push({name: 'Login'})
            },
            _handleBlur() {
                setTimeout(() => {
                    this.searchFocus = false
                }, 300)
            }
        },
    }
</script>
<style lang="scss">
    .service-center-header {
        position: sticky;
        top: 0;
        z-index: 11;

        .ivu-layout-header {
            padding: 0 50px 0 10px;
        }

        .search-container-header {
            display: inline-block;
            margin-left: 40px;

            &.active {
                .search-btn {
                    display: inline-block;
                }

                .class-search {
                    border: 1px solid #ED6C00;
                    width: 460px;
                    transition: all .2s ease-in-out;
                }
            }

            .ivu-icon-md-search {
                left: 34px;
                color: #cacaca;
                position: relative;
                z-index: 2;
            }

            .search-btn {
                background: #ED6C00;
                border-radius: 13px;
                width: 66px;
                height: 26px;
                font-size: 13px;
                line-height: 26px;
                color: #FFFFFF;
                position: relative;
                left: -70px;
                display: none;
                outline: none;
                border: 0;
            }

            .class-search {
                display: inline-block;
                width: 220px;
                position: relative;
                border: 1px solid #E3E3E3;
                box-sizing: border-box;
                border-radius: 16px;

                .ivu-input {
                    color: #202020;
                    border: none;
                    width: 80%;
                    font-size: 13px;
                    margin-left: 30px;

                    &::placeholder {
                        color: #8C8C8C;
                    }

                    &:focus {
                        box-shadow: inherit;
                        border: none;
                    }
                }

                .ivu-input-icon {
                    outline: none;
                }
            }

        }

        .notice {
            height: 30px;
            line-height: 30px;
            background: #ed6c00;
            text-align: center;
            font-size: 14px;
            color: #fff;

            a {
                margin-left: 4px;
                color: #fff;
                text-decoration: underline;
            }
        }

        .ivu-layout-header {
            background: #fff;
            border-bottom: 1px solid #ebebeb;
            width: 100%;
            z-index: 11;
            min-width: 1280px;

            .header_wrapper {
                position: relative;
                display: flex;
                margin: auto;

                .left {
                    flex: 1;

                    img {
                        width: 40px;
                        height: 40px;
                        position: relative;
                        top: 10px;
                        cursor: pointer;
                    }

                    .title {
                        margin-left: 10px;
                        position: relative;
                        font-size: 16px;
                        font-weight: 500;
                        color: #1f1f1f;
                    }

                    .sub_title {
                        margin-left: 16px;
                        font-size: 12px;
                        color: #868688;
                    }
                }

                .center {
                    display: flex;

                    .nav_item {
                        position: relative;
                        margin: 0 16px;
                        cursor: pointer;
                        color: #000;
                        transition: all .3s;

                        &:hover {
                            color: #ed6c00;
                        }

                        &.active {
                            color: #ed6c00;

                            &::after {
                                content: '';
                                display: block;
                                position: absolute;
                                width: 100%;
                                height: 2px;
                                background: #ed6c00;
                                top: 48px;
                            }
                        }
                    }
                }

                .right {
                    margin-left: 70px;

                    .welcome-info {
                        margin-right: 40px;
                        font-size: 14px;
                    }

                    .update-info {
                        margin-right: 35px;
                        cursor: pointer;
                        background: #F8F8F8;
                        border-radius: 16px;
                        width: 140px;
                        height: 32px;
                        line-height: 32px;
                        display: inline-block;
                        text-align: center;

                        .text {
                            font-style: normal;
                            font-weight: normal;
                            font-size: 12px;
                            line-height: 32px;
                            color: #444444;
                            position: relative;
                            top: -2px
                        }

                        .search-mail {
                            font-size: 20px;
                            cursor: pointer;
                            color: #ED6C00;
                            width: 20px;
                            position: relative;
                            right: 8px;
                            top: 3px
                        }
                    }

                    .search-mail {
                        font-size: 20px;
                        cursor: pointer;
                        color: #ED6C00;
                        width: 20px;
                        position: relative;
                        right: 20px;
                        top: 5px

                    }
                }
            }
        }

    }

</style>
